export {QuoteSmall} from './lib/quote-small';